import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
})
export class AppComponent {
  email: string;
  password: string;
  location: string;
  logoUrl = environment.logo || '';
  navbarColor = environment.navbar_color || '';
  navbarTextColor = environment.navbar_text_color || '';

  constructor(
    public authService: AuthService,
    private title: Title,
  ) {
    this.title.setTitle(environment.title || 'Infokanal');
  }

  login() {
    this.authService.login(this.email, this.password);
    this.password = '';
  }

  logout() {
    this.authService.logout();
    this.location = '';
  }
}
